import { Component, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Catalog } from '../../../rewards/interfaces/search-catalog-response.interface';

@Component({
  selector: 'app-shared-article-add-success-modal',
  templateUrl: './sharedwishlist-item-added-modal.component.html',
})
export class SharedWishlistItemAddedModalComponent {
  private ngbActiveModal = inject(NgbActiveModal);
  private router = inject(Router);

  article = signal<Catalog | null>(null);

  closeModal() {
    this.ngbActiveModal.close();
  }

  viewWishList() {
    this.closeModal();
    this.router.navigate(['/shared-home/wishlist']);
  }
}
